import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import FrameworkUtils from 'utils/framework';
import { isAnonymousSelector } from 'selectors/auth/isAnonymousSelector';
import { showBiSignInUpAccountCopyUpdateSelector } from 'viewModel/selectors/testTarget/showBiSignInUpAccountCopyUpdateSelector';

const { wrapHOC } = FrameworkUtils;
const fields = createStructuredSelector({
    isAnonymous: isAnonymousSelector,
    showBiSignInUpAccountCopyUpdate: showBiSignInUpAccountCopyUpdateSelector
});

const functions = null;

const withAccountGreetingProps = wrapHOC(connect(fields, functions));

export {
    withAccountGreetingProps, fields, functions
};
